import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const s = {
  page: { minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', background: '#faf7f2' },
  card: { background: '#fff', border: '1px solid #e2dbd0', borderRadius: 20, padding: '2.5rem', width: '100%', maxWidth: 440, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' },
  logo: { fontFamily: 'Fraunces, serif', fontSize: '1.5rem', fontWeight: 600, color: '#1c1814', textAlign: 'center', marginBottom: '0.5rem' },
  logoSpan: { color: '#c0392b' },
  title: { fontSize: '1.4rem', fontWeight: 600, textAlign: 'center', marginBottom: '0.5rem', color: '#1c1814' },
  sub: { textAlign: 'center', color: '#7a6f65', fontSize: '0.875rem', marginBottom: '2rem' },
  field: { marginBottom: '1.25rem' },
  label: { display: 'block', fontSize: '0.82rem', fontWeight: 600, color: '#3d3530', marginBottom: '0.4rem' },
  input: { width: '100%', padding: '0.75rem 1rem', border: '1.5px solid #e2dbd0', borderRadius: 10, fontSize: '0.9rem', outline: 'none', fontFamily: 'inherit', background: '#faf7f2', boxSizing: 'border-box' },
  btn: { width: '100%', background: '#c0392b', color: '#fff', border: 'none', borderRadius: 10, padding: '0.875rem', fontSize: '0.95rem', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', marginTop: '0.5rem' },
  error: { background: '#fdf0ee', color: '#c0392b', padding: '0.75rem 1rem', borderRadius: 8, fontSize: '0.85rem', marginBottom: '1rem', textAlign: 'center' },
  link: { textAlign: 'center', marginTop: '1.5rem', fontSize: '0.875rem', color: '#7a6f65' },
  linkA: { color: '#c0392b', fontWeight: 600, textDecoration: 'none' },
};

export default function Register() {
  const [form, setForm] = useState({ fullName: '', email: '', password: '', phone: '', linkedinUrl: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await register(form);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>Layoff<span style={s.logoSpan}>Fund</span></div>
        <h2 style={s.title}>Create your account</h2>
        <p style={s.sub}>Start a campaign or support others</p>
        {error && <div style={s.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          {[
            { key: 'fullName', label: 'Full name', type: 'text', placeholder: 'Santosh Pujeri' },
            { key: 'email', label: 'Email', type: 'email', placeholder: 'you@example.com' },
            { key: 'password', label: 'Password', type: 'password', placeholder: 'Min 8 characters' },
            { key: 'phone', label: 'Phone (optional)', type: 'tel', placeholder: '+91 98765 43210' },
            { key: 'linkedinUrl', label: 'LinkedIn URL (optional)', type: 'url', placeholder: 'https://linkedin.com/in/...' },
          ].map(({ key, label, type, placeholder }) => (
            <div key={key} style={s.field}>
              <label style={s.label}>{label}</label>
              <input style={s.input} type={type} value={form[key]} placeholder={placeholder}
                required={key !== 'phone' && key !== 'linkedinUrl'}
                onChange={e => setForm({ ...form, [key]: e.target.value })} />
            </div>
          ))}
          <button style={s.btn} type="submit" disabled={loading}>
            {loading ? 'Creating account...' : 'Create account →'}
          </button>
        </form>
        <div style={s.link}>
          Already have an account? <Link to="/login" style={s.linkA}>Log in</Link>
        </div>
      </div>
    </div>
  );
}
